// @ts-strict-ignore
import { type PropsWithChildren, useEffect, useRef } from 'react';

import { Footer } from '~/components/Footer/footer';
import { IziBanner } from '~/components/IziBanner';
import { Navbar } from '~/components/Navbar/Navbar';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { ListsContextProvider } from '~/contexts/ListsContext/ListsContext';
import { ToastContextProvider } from '~/contexts/ToastContext/ToastContext';
import { useHeightObserver } from '~/hooks';

type LayoutProps = {
  jobList: string[];
  cityList: string[];
  sectorList: string[];
};

export const Layout = ({ children, jobList, cityList, sectorList }: PropsWithChildren<LayoutProps>) => {
  const componentRef = useRef();
  const { iframe } = useBusinessUnitContext();
  const height = useHeightObserver(componentRef);

  useEffect(() => {
    window.parent?.postMessage(JSON.stringify({ type: 'onHeightChanged', height }), '*');
  }, [height]);

  return (
    <ToastContextProvider>
      <ListsContextProvider jobList={jobList} cityList={cityList} sectorList={sectorList}>
        {!iframe && <Navbar />}
        <main ref={componentRef}>{children}</main>
        {!iframe && (
          <>
            <IziBanner />
            <Footer />
          </>
        )}
      </ListsContextProvider>
    </ToastContextProvider>
  );
};
